import React, { useEffect, useRef, useState, useCallback } from "react";
import { Camera, Plus, Trash2, Upload } from "lucide-react";
import { useSelector } from "react-redux";
import ProfileBackground from "../../../../../assets/images/profile-background.png";
import ProfileImage from "../../../../../assets/images/profile-image.png";
import Avatar from "../../../../../assets/svgs/avatar_green.svg";
import Coverimage from "../../../../../assets/svgs/Cover-Image.svg";
import { getApi, putApi, deleteApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import {
  appendJsonSection,
  appendProfileFiles,
  buildBasicInfoPayload,
  buildContactsFromMyProfile,
  getProfileImageUrl,
} from "../../../../Organization/components/Users/Profile/profileFormUtils";
import PopupCard from "../../../../Auth/PopupCard";
const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Côte d'Ivoire",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia (Czech Republic)",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holy See",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine State",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

const mapProfileToForm = (profile) => {
  const contacts = profile?.contacts || [];
  const firstContact = contacts[0] || {};
  const secondContact = contacts[1] || {};
  const primaryContact =
    contacts.find((contact) => contact?.isPrimary) || firstContact;

  return {
    name: profile?.name || "",
    username: profile?.username || profile?.email || "",
    userId: profile?.userId || profile?.employee_id || "",
    location: profile?.location || profile?.profileCountry || "",
    contactNumber_1: firstContact.contactNumber || "",
    contactNumber_2: secondContact.contactNumber || "",
    emailId_1: firstContact.email || "",
    emailId_2: secondContact.email || "",
    primaryContactNumber: primaryContact.contactNumber || "",
    primaryEmailId: primaryContact.email || "",
    description: profile?.description || "",
  };
};

export default function MyProfile() {
  const { user } = useSelector((state) => state.auth);
  const profileImageInputRef = useRef(null);
  const bannerImageInputRef = useRef(null);
  const [popup, setpopup] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loginEmail, setLoginEmail] = useState("");
  const [profileImagePreview, setProfileImagePreview] = useState("");
  const [bannerImagePreview, setBannerImagePreview] = useState("");
  const [role, setRole] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const [pendingFiles, setPendingFiles] = useState({
    profileImageFile: null,
    bannerImageFile: null,
  });
  const [basicInformation, setBasicInformation] = useState({
    name: "",
    username: "",
    userId: "",
    location: "",
    contactNumber_1: "",
    contactNumber_2: "",
    emailId_1: "",
    emailId_2: "",
    primaryContactNumber: "",
    primaryEmailId: "",
    description: "",
  });

  const fetchProfile = async () => {
    setLoading(true);
    try {
      const response = await getApi({ apiUrl: API_URLS.GET_EMP_PROFILE });
      if (response?.success && response.data) {
        setProfile(response.data);
        setLoginEmail(response.data.email || "");
        setBasicInformation(mapProfileToForm(response.data));
      }
    } catch (error) {
      console.error("Unable to get employee profile", error);
      setpopup({
        title: "Failed",
        type: "error",
        message: "Failed to load profile",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const role = user?.subAdmin?.isSubAdmin
      ? "Sub Admin"
      : user?.role?.join(", ") || "";

    setRole(role);
    fetchProfile();
  }, [user]);

  const handleChange = (e) => {
    setBasicInformation((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  useEffect(() => {
    if (!popup) return;

    const timer = setTimeout(() => {
      setpopup(null);
    }, 3000);

    return () => clearTimeout(timer);
  }, [popup]);
  const handlePrimarySelection = (option) => {
    if (option === "contact_1") {
      setBasicInformation((prev) => ({
        ...prev,
        primaryContactNumber: prev.contactNumber_1,
        primaryEmailId: prev.emailId_1,
      }));
    } else if (option === "contact_2") {
      setBasicInformation((prev) => ({
        ...prev,
        primaryContactNumber: prev.contactNumber_2,
        primaryEmailId: prev.emailId_2,
      }));
    }
  };

  const uploadImageInstantly = async (fileKey, fileValue) => {
    setSaving(true);
    try {
      const formData = new FormData();
      formData.append(fileKey, fileValue);
      const response = await putApi({
        apiUrl: API_URLS.UPDATE_EMP_PROFILE,
        data: formData,
      });
      if (response?.success) {
        setpopup({
          title: "Success",
          type: "success",
          message: "Image updated successfully",
        });
        setPendingFiles((prev) => ({ ...prev, [fileKey]: null }));
        if (fileKey === "profileImageFile") setProfileImagePreview("");
        if (fileKey === "bannerImageFile") setBannerImagePreview("");
        await fetchProfile();
      } else {
        setpopup({
          title: "Failed",
          type: "error",
          message: response?.message || "Failed to update image",
        });
      }
    } catch (e) {
      setpopup({
        title: "Failed",
        type: "error",
        message: "Failed to update image",
      });
    } finally {
      setSaving(false);
    }
  };

  const handleImageSelect = async (type, file) => {
    if (!file) return;
    const preview = URL.createObjectURL(file);
    if (type === "profile") {
      setProfileImagePreview(preview);
      await uploadImageInstantly("profileImageFile", file);
    } else {
      setBannerImagePreview(preview);
      await uploadImageInstantly("bannerImageFile", file);
      setShowDropdown(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const formData = new FormData();
      appendJsonSection(
        formData,
        "basicInfo",
        buildBasicInfoPayload(basicInformation),
      );
      appendJsonSection(
        formData,
        "contacts",
        buildContactsFromMyProfile(basicInformation),
      );
      appendProfileFiles(formData, pendingFiles);

      const response = await putApi({
        apiUrl: API_URLS.UPDATE_EMP_PROFILE,
        data: formData,
      });

      if (response?.success === false) {
        setpopup({
          title: "Failed",
          type: "error",
          message: response?.message || "Failed to update profile",
        });
        return;
      }

      setpopup({
        title: "Sucess",
        type: "success",
        message: response?.message || "Profile updated successfully",
      });
      setPendingFiles({ profileImageFile: null, bannerImageFile: null });
      setProfileImagePreview("");
      setBannerImagePreview("");
      await fetchProfile();
    } catch (error) {
      setpopup({
        title: "Error",
        type: "error",
        message: error?.message || "Failed to update profile",
      });
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteBanner = async () => {
    if (bannerImagePreview) {
      setBannerImagePreview("");
      setPendingFiles((prev) => ({ ...prev, bannerImageFile: null }));
      return;
    }
    if (profile?.bannerImage?.filePath) {
      try {
        setSaving(true);
        const response = await deleteApi({
          apiUrl: API_URLS.DELETE_EMP_PROFILE_IMAGE("bannerImage"),
        });
        if (response?.success) {
          setpopup({
            title: "Success",
            type: "success",
            message: "Cover image deleted successfully",
          });
          await fetchProfile();
        } else {
          setpopup({
            title: "Failed",
            type: "error",
            message: response?.message || "Failed to delete cover image",
          });
        }
      } catch (error) {
        setpopup({
          title: "Failed",
          type: "error",
          message: error?.message || "Failed to delete cover image",
        });
      } finally {
        setSaving(false);
      }
    }
  };

  const handleDeleteProfile = async () => {
    if (profileImagePreview) {
      setProfileImagePreview("");
      setPendingFiles((prev) => ({ ...prev, profileImageFile: null }));
      return;
    }
    if (profile?.profileImage?.filePath) {
      try {
        setSaving(true);
        const response = await deleteApi({
          apiUrl: API_URLS.DELETE_EMP_PROFILE_IMAGE("profileImage"),
        });
        if (response?.success) {
          setpopup({
            title: "Success",
            type: "success",
            message: "Profile image deleted successfully",
          });
          await fetchProfile();
        } else {
          setpopup({
            title: "Failed",
            type: "error",
            message: response?.message || "Failed to delete profile image",
          });
        }
      } catch (error) {
        setpopup({
          title: "Failed",
          type: "error",
          message: error?.message || "Failed to delete profile image",
        });
      } finally {
        setSaving(false);
      }
    }
  };

  const bannerSrc =
    bannerImagePreview ||
    getProfileImageUrl(profile?.bannerImage?.filePath) ||
    ProfileBackground;

  const avatarSrc =
    profileImagePreview ||
    getProfileImageUrl(profile?.profileImage?.filePath) ||
    Avatar;

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden px-4 sm:px-6 lg:px-10">
      <div className="relative w-full bg-gray-100 my-2 rounded-lg overflow-hidden">
        <img
          src={bannerSrc}
          alt="Cover"
          className="w-full h-48 sm:h-56 lg:h-64 block object-cover object-center bg-gray-200"
        />
        <input
          ref={bannerImageInputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp"
          className="hidden"
          onChange={(e) => {
            handleImageSelect("banner", e.target.files?.[0]);
            e.target.value = ""; // allow selecting same file again
          }}
        />
        <div className="absolute top-4 right-4 z-10">
          <button
            type="button"
            onClick={() => setShowDropdown(!showDropdown)}
            className="bg-white/90 backdrop-blur-sm p-2 rounded-md shadow hover:bg-white transition-colors"
          >
            <Camera size={18} className="text-gray-700" />
          </button>

          {showDropdown && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg overflow-hidden border border-gray-200">
              <button
                onClick={() => {
                  bannerImageInputRef.current?.click();
                  setShowDropdown(false);
                }}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
              >
                <Upload size={16} /> Upload Photo
              </button>
              {(bannerImagePreview || profile?.bannerImage?.filePath) && (
                <button
                  onClick={() => {
                    handleDeleteBanner();
                    setShowDropdown(false);
                  }}
                  disabled={saving}
                  className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 disabled:opacity-50"
                >
                  <Trash2 size={16} /> Remove Photo
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="relative px-4 sm:px-6 lg:px-8">
        <div className="relative -mt-12 mb-6">
          <div className="flex flex-col sm:flex-row items-start justify-between gap-4 ml-4">
            <div className="flex items-center gap-4">
              <div className="relative">
                <img
                  src={avatarSrc}
                  alt="Profile"
                  className="w-20 h-20 rounded-full border-4 border-white shadow-lg object-cover bg-[#1F5A40]"
                />
                <input
                  ref={profileImageInputRef}
                  type="file"
                  accept="image/jpeg,image/png,image/webp"
                  className="hidden"
                  onChange={(e) => {
                    handleImageSelect("profile", e.target.files?.[0]);
                    e.target.value = "";
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                  className="absolute bottom-0 right-0 bg-teal-600 text-white p-1.5 rounded-full hover:bg-teal-700 transition-colors shadow-md"
                >
                  <Camera size={14} />
                </button>

                {showProfileDropdown && (
                  <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg overflow-hidden border border-gray-200 z-50">
                    <button
                      onClick={() => {
                        profileImageInputRef.current?.click();
                        setShowProfileDropdown(false);
                      }}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                    >
                      <Upload size={16} /> Upload Photo
                    </button>
                    {(profileImagePreview ||
                      profile?.profileImage?.filePath) && (
                      <button
                        onClick={() => {
                          handleDeleteProfile();
                          setShowProfileDropdown(false);
                        }}
                        disabled={saving}
                        className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 disabled:opacity-50"
                      >
                        <Trash2 size={16} /> Remove Photo
                      </button>
                    )}
                  </div>
                )}
              </div>
              <div className="mt-10">
                <h1 className="text-2xl font-bold text-gray-900 mb-0.5">
                  {basicInformation.name || user?.name}
                </h1>
                <p className="text-gray-600 mb-0">
                  User ID/ {basicInformation.userId}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md border border-[#3BA2B959] mb-6">
          <div className="p-4 sm:p-6">
            <div className="mb-8">
              <h2 className="text-lg font-semibold text-[#06513D] mb-4">
                Basic Information
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={basicInformation.name}
                    onChange={handleChange}
                    disabled={loading}
                    className="w-full border-b border-gray-300 px-2 py-2 focus:outline-none focus:border-[#06513D]"
                    placeholder="Enter your name"
                  />
                </div>
                {/* <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Username
                  </label>
                  <input
                    type="text"
                    name="username"
                    value={basicInformation.username}
                    onChange={handleChange}
                    disabled={loading}
                    className="w-full border-b border-gray-300 px-2 py-2 focus:outline-none focus:border-[#06513D]"
                    placeholder="Enter username"
                  />
                </div> */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email / Username (login)
                  </label>
                  <input
                    type="email"
                    value={loginEmail}
                    readOnly
                    className="w-full border-b border-gray-300 px-2 py-2 bg-gray-50 text-gray-600 cursor-not-allowed"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    User ID
                  </label>
                  <input
                    type="text"
                    name="userId"
                    value={basicInformation.userId}
                    readOnly
                    className="w-full border-b border-gray-300 px-2 py-2 bg-gray-50 text-gray-600 cursor-not-allowed"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Role
                  </label>
                  <input
                    type="text"
                    name="role"
                    value={role}
                    readOnly
                    className="capitalize w-full border-b border-gray-300 px-2 py-2 bg-gray-50 text-gray-600 cursor-not-allowed"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Location
                  </label>
                  <select
                    name="location"
                    value={basicInformation.location}
                    onChange={handleChange}
                    disabled={loading}
                    className="w-full border-b border-gray-300 px-2 py-2 focus:outline-none focus:border-[#06513D]"
                  >
                    <option value="">Select a country</option>
                    {basicInformation.location &&
                      !countries.includes(basicInformation.location) && (
                        <option value={basicInformation.location}>
                          {basicInformation.location}
                        </option>
                      )}
                    {countries.map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="px-0 sm:px-2">
              <h2 className="text-lg font-semibold text-[#06513D] mb-4">
                Contact Details
              </h2>
              <div className="space-y-6">
                <div className="flex flex-col sm:flex-row justify-between gap-4 sm:gap-5 items-start sm:items-center">
                  <div className="w-full sm:flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      1. Contact Number
                    </label>
                    <input
                      type="tel"
                      name="contactNumber_1"
                      value={basicInformation.contactNumber_1}
                      onChange={handleChange}
                      className="w-full border-b border-gray-300 px-2 py-2 focus:outline-none focus:border-[#06513D]"
                      placeholder="Enter contact number"
                    />
                  </div>
                  <div className="w-full sm:flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email ID
                    </label>
                    <input
                      type="email"
                      name="emailId_1"
                      value={basicInformation.emailId_1}
                      onChange={handleChange}
                      className="w-full border-b border-gray-300 px-2 py-2 focus:outline-none focus:border-[#06513D]"
                      placeholder="Enter email address"
                    />
                  </div>
                  <div className="flex items-center gap-2 pt-2 sm:pt-0">
                    <input
                      type="radio"
                      id="primary_1"
                      name="primaryContact"
                      onChange={() => handlePrimarySelection("contact_1")}
                      checked={
                        basicInformation.primaryContactNumber ===
                        basicInformation.contactNumber_1
                      }
                      className="w-4 h-4 text-[#06513D] focus:ring-[#06513D]"
                    />
                    <label
                      htmlFor="primary_1"
                      className="text-sm text-gray-700"
                    >
                      Make it Primary
                    </label>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row justify-between gap-4 sm:gap-5 items-start sm:items-center">
                  <div className="w-full sm:flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      2. Contact Number
                    </label>
                    <input
                      type="tel"
                      name="contactNumber_2"
                      value={basicInformation.contactNumber_2}
                      onChange={handleChange}
                      className="w-full border-b border-gray-300 px-2 py-2 focus:outline-none focus:border-[#06513D]"
                      placeholder="Enter contact number"
                    />
                  </div>
                  <div className="w-full sm:flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email ID
                    </label>
                    <input
                      type="email"
                      name="emailId_2"
                      value={basicInformation.emailId_2}
                      onChange={handleChange}
                      className="w-full border-b border-gray-300 px-2 py-2 focus:outline-none focus:border-[#06513D]"
                      placeholder="Enter email address"
                    />
                  </div>
                  <div className="flex items-center gap-2 pt-2 sm:pt-0">
                    <input
                      type="radio"
                      id="primary_2"
                      name="primaryContact"
                      onChange={() => handlePrimarySelection("contact_2")}
                      checked={
                        basicInformation.primaryContactNumber ===
                        basicInformation.contactNumber_2
                      }
                      className="w-4 h-4 text-[#06513D] focus:ring-[#06513D]"
                    />
                    <label
                      htmlFor="primary_2"
                      className="text-sm text-gray-700"
                    >
                      Make it Primary
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description
                </label>
                <textarea
                  name="description"
                  value={basicInformation.description}
                  onChange={handleChange}
                  rows={4}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#06513D] focus:border-transparent resize-none"
                  placeholder="Add a description..."
                />
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-6">
          <button
            type="button"
            onClick={handleSave}
            disabled={saving || loading}
            className="bg-[#06513D] text-white text-sm px-10 py-3 rounded-md hover:!bg-[#387464] disabled:opacity-60"
          >
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>

        {popup && (
          <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center pointer-events-none">
            <PopupCard
              title={popup.title}
              type={popup.type}
              message={popup.message}
              onClose={() => setpopup(null)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
